<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <ImportTrackList :isImport='true'></ImportTrackList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import ImportTrackList from '../../components/trackconfig/importTrack/ImportTrackList';

export default {
  name: 'ImportTrackPage',
  components: {
    BasicLayout,
    ImportTrackList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Track.signManage')}/${this.$t('Track.importTrackData')}`
      }
    };
  }
};
</script>